export default __webpack_public_path__ + "static/media/1.0f8d9ec1.png";